<div class="login-page">

  <!-- Background decoration -->
  <div class="login-bg-decoration"></div>

  <div class="login-card-wrapper">
    <div class="login-card">

      <!-- Header -->
      <div class="login-card-header">
        <div class="login-logo">
          <i class="bi bi-boxes"></i>
        </div>
        <h2 class="login-title">SchucoGate</h2>
        <p class="login-subtitle">Sign in to your account</p>
      </div>

      <!-- Form -->
      <div class="login-card-body">
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">

          <div class="form-field-group">
            <label for="loginInputEmail" class="login-label">
              <i class="bi bi-envelope-fill"></i> Email address
            </label>
            <input formControlName="email" type="email" class="login-input"
              id="loginInputEmail" placeholder="Enter your email" autocomplete="email" />
          </div>

          <div class="form-field-group">
            <label for="loginInputPassword" class="login-label">
              <i class="bi bi-lock-fill"></i> Password
            </label>
            <input formControlName="password" type="password" class="login-input"
              id="loginInputPassword" placeholder="Enter your password" autocomplete="current-password" />
          </div>

          <button type="submit" class="btn-login-submit">
            <i class="bi bi-box-arrow-in-right me-2"></i> Log In
          </button>

        </form>
      </div>

    </div>
  </div>

</div>